
import { Row, Col } from 'react-bootstrap';

import TrafficLight from './TrafficLight.js';

function SewageOperatorMapFooter({ showUnmatchedExplaination = true }) {

	return <div>
		<Row className="justify-content-center align-items-center">
			<Col xs={12} className="header-bold text-white bg-dark mb-1">How to read the traffic lights</Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        <TrafficLight status={"STOP"} />
		    </Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        <TrafficLight status={"OFFLINE"} />
		    </Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        <TrafficLight status={"START"} />
		    </Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        All stations online and not discharging
		    </Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        No discharging stations, but some are not reporting their status (offline)
		    </Col>
		    <Col xs={4} className="d-flex justify-content-center">
		        At least one station is discharging
		    </Col>
		</Row>
		{showUnmatchedExplaination ? <span>
			<hr />
			<b>A note from floodmapper</b>: <b><i>What does it mean when a EDM outlet is unmatched?</i></b><br />
			<span>We have cross-referenced the data here with the EDM reports submitted by providers to the EA at the end of each year. Our matching allows us to state which outlet refers to which historical record, making the data more insightful. This allows you to view recent activity in the context of historical trends, helping to identify whether recent events are abnormal compared to previous years. If you think we have got a matching wrong, please let us know.
			<br />We are only a small site, but we have matched around 12,000 outlets to their historical records so far and expanding our tracking efforts remains an ongoing priority.</span>
			<br />It is important to note: <b>All spills, including unmatched, are still presented on our site and we are not filtering any data</b>
		</span> : null}
		<hr />
		<span style={{fontSize: "0.7em"}}><b>We are not affiliated with, or endorsed by, any of the entities mentioned on this page</b></span>
	</div>
}


export default SewageOperatorMapFooter;